import { motion } from 'framer-motion';
import { posts } from '../data';
import PostCard from '../components/PostCard';
import { BookOpen } from 'lucide-react';

export default function Posts() {
  return (
    <div className="min-h-screen pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center space-x-3 mb-4">
            <BookOpen className="text-pink-400" size={32} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            文章列表
          </h1>
          <p className="text-xl text-pink-200/70 max-w-2xl mx-auto">
            分享技术学习笔记，记录生活点滴
          </p>
        </motion.div>

        {/* Posts Grid */}
        {posts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post, index) => (
              <PostCard key={post.id} post={post} index={index} />
            ))}
          </div>
        ) : (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-20"
          >
            <p className="text-gray-500 text-lg">暂无文章，敬请期待...</p>
          </motion.div>
        )}
      </div>
    </div>
  );
}
